import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InputField from "@src/common/InputField"
import ReactSelect from '@common/ReactSelect';
import { getLocalityList,getCityList } from '@src/store/slices/common';
import { APP_TYPE_AGENCY, COUNTRY_CODE, FEATURE_LISTING, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';
import { POLICY_HOLDER } from '@src/config/id/constant';



export default function ResidentialInformation(props: any): ReturnType<React.FC> {
    const commonState = useSelector((state: any) => state.common);
    const insuranceState = useSelector((state: any) => state.insurance)
    const { application_type_id } = insuranceState?.leadDetail || {}

    let [perCity, setPerCity] = useState<any>([]);
    let [curCity, setCurCity] = useState<any>([]);
    let [perLocality, setPerLocality] = useState<any>([]);
    let [curLocality, setCurLocality] = useState<any>([]);
    let [curFieldDisable, setCurFieldDisable] = useState<boolean>(false)
    let [perDistrict, setperDistrict] = useState<any>([]);
    let [curDistrict, setCurDistrict] = useState<any>([]);
    let [isFieldReq, setIsFieldReq] = useState(true)
    const {translations} = useLanguage();

    const dispatch: any = useDispatch();
    const postalCodeRegex = /^\d{5}$/;
    const postalCodeError = "";

     let policy_type_id = (COUNTRY_CODE === 'id' && insuranceState?.leadDetail?.policy_type_id) 
    ? insuranceState.leadDetail.policy_type_id 
    : POLICY_HOLDER['PERSONAL'];

    const CityList = commonState.city;
    const districtList = commonState.locality;
        
    useEffect(() => {        
        const perState = Number(props?.residentialDetails?.per_province);
        const curState = Number(props?.residentialDetails?.cur_province);

        const perCityId = Number(props?.residentialDetails?.per_city);
        const curCityId = Number(props?.residentialDetails?.cur_city);

        let stateArr = [perState, curState].filter(Boolean);
        let cityArr = [perCityId, curCityId].filter(Boolean);

        stateArr = [...new Set(stateArr)];
        cityArr = [...new Set(cityArr)];



        const needsCityList =
            stateArr.length > 0 &&
            stateArr.some(
                (sid) => !CityList.some((c: any) => +c.state_id === +sid)
            );

            
        if (needsCityList) {
            props.setLoading(true);
            dispatch(getCityList({ state: stateArr })).finally(() =>
                props.setLoading(false)
            );
        }

        if (COUNTRY_CODE === 'id') {
            const needsDistrictList =
                cityArr.length > 0 &&
                cityArr.some(
                    (cid) => !districtList.some((d: any) => +d.city_id === +cid)
                );

            if (needsDistrictList) {
                props.setLoading(true);
                dispatch(getLocalityList({ city: cityArr })).finally(() =>
                    props.setLoading(false)
                );
            }
        }

        syncResidentialOptionsFromStore();
    }, [
        application_type_id,
        CityList,
        districtList,
        props?.residentialDetails?.per_region,
        props?.residentialDetails?.cur_region,
        props?.residentialDetails?.per_province,
        props?.residentialDetails?.cur_province,
        props?.residentialDetails?.per_city,
        props?.residentialDetails?.cur_city,
        props?.residentialDetails?.per_barangay,
        props?.residentialDetails?.cur_barangay,
        props?.residentialDetails?.per_sameas_cur,
        props?.residentialDetails?.same_as_ktp_address,
    ]);

    const syncResidentialOptionsFromStore = () => {

        if (props?.residentialDetails?.per_region || props?.residentialDetails?.per_province) {
            const perStateId = Number(
                props.residentialDetails.per_region ||
                    props?.residentialDetails?.per_province
            );
            const per_city_options = CityList.filter(
                (el: any) => +el.state_id === perStateId
            );
            
            setPerCity([...per_city_options]);
        }
        if (props?.residentialDetails?.cur_region || props?.residentialDetails?.cur_province) {
            const curStateId = Number(
                props?.residentialDetails?.cur_region ||
                    props?.residentialDetails?.cur_province
            );
            const cur_city_options = CityList.filter(
                (el: any) => +el.state_id === curStateId
            );
            setCurCity([...cur_city_options]);
        }
        if (props?.residentialDetails?.cur_city) {
            if (districtList?.length) {
                let district = districtList.filter(
                    (el: any) => +el.city_id === +props?.residentialDetails?.cur_city
                );
                setCurDistrict([...district]);
            }
        }
        if (props?.residentialDetails?.per_city) {
            if (districtList?.length) {
                let district = districtList.filter(
                    (el: any) => +el.city_id === +props?.residentialDetails?.per_city
                );
                setperDistrict([...district]);
            }
        }
        if (+props?.residentialDetails?.per_sameas_cur === 2 || +props?.residentialDetails?.same_as_ktp_address === 2) {
            setCurFieldDisable(true);
        }
        if(COUNTRY_CODE === 'ph'){
            let fieldReq  = (application_type_id === APP_TYPE_AGENCY)?false:true;
            setIsFieldReq(fieldReq);
        }
    }

    const updatePostalCodeErrors = (formFields: any) => {
        if (typeof props.setErrors !== 'function') return;

        props.setErrors((prevErrors: any) => {
            const updatedErrors = { ...prevErrors };

            ['per_postal_code', 'cur_postal_code'].forEach((fieldKey: string) => {
                const fieldValue = formFields?.[fieldKey];
                const value = fieldValue === undefined || fieldValue === null ? '' : String(fieldValue).trim();

                if (!value) {
                    // updatedErrors[fieldKey] = translations?.commonMsg?.FIELD_CANNOT_BE_BLANK;
                } else if (!postalCodeRegex.test(value)) {
                    updatedErrors[fieldKey] = postalCodeError;
                } else {
                    delete updatedErrors[fieldKey];
                }
            });

            return updatedErrors;
        });
    }

    const changeHandler = async (value: any, key: string) => {
        let formFields: any = props.residentialDetails;
        let residentialDetailsForID = ['housing', 'rt', 'rw', 'province', 'district', 'sub_district', 'same_as_ktp_address','postal_code']

        if (key === 'per_full_address') {
            let curvalue = {};
            if (formFields["per_sameas_cur"] === 2) {
                curvalue = { cur_full_address: value.target.value }
            }
            formFields = { ...formFields, [key]: value.target.value, ...curvalue }
        }
        else if (key === 'per_house_no') {
            let curvalue = {};
            if (formFields["per_sameas_cur"] === 2) {
                curvalue = { cur_house_no: value.target.value }
            }
            formFields = { ...formFields, [key]: value.target.value, ...curvalue }
        } else if (key === 'per_street') {
            let curvalue = {};
            if (formFields["per_sameas_cur"] === 2) {
                curvalue = { cur_street: value.target.value }
            }
            formFields = { ...formFields, [key]: value.target.value, ...curvalue }
        } else if (key === "per_region") {
            let per_city = commonState.city.filter((el: any) => +el.state_id === +value.value);
                if (!(per_city && per_city.length)) {
                    props.setLoading(true)
                    let stateArray = [+value.value]
                    if (formFields.cur_region) stateArray.push(+formFields.cur_region)
                    per_city = await dispatch(getCityList({ state: stateArray }))
                    per_city = per_city?.data?.filter((e: any) => e.state_id === +value.value) || []
                    props.setLoading(false)
                }
            setPerCity([...per_city]);
            let curvalue = {};
            if (formFields["per_sameas_cur"] === 2) {
                curvalue = { cur_region: value.value, cur_city: null, cur_barangay: null }
            }
            formFields = { ...formFields, [key]: value.value, ...curvalue, per_city: null, per_barangay: null }

        } else if (key === "cur_region") {
            let cur_city = commonState.city.filter((el: any) => +el.state_id === +value.value);
            if (!(cur_city && cur_city.length)) {
                props.setLoading(true)
                let stateArray = [+value.value]
                if (formFields.per_region) stateArray.push(+formFields.per_region)
                cur_city = await dispatch(getCityList({ state: stateArray }))
                cur_city = cur_city?.data?.filter((e: any) => e.state_id === +value.value) || []
                props.setLoading(false)
            }
            setCurCity([...cur_city]);

            formFields = { ...formFields, [key]: value.value, cur_city: null, cur_barangay: null }

        } else if (key === "per_city") {
            let curvalue: any = {};

            if (COUNTRY_CODE === 'id') {
                let district: any = await fetchDistrictList([+value.value])

                if (district?.length) {
                    setperDistrict(district)
                }
                if (formFields['same_as_ktp_address'] === 2) {
                    curvalue = { cur_city: value.value }
                    curvalue['cur_district'] = null

                    setCurDistrict(district)
                }
                formFields['per_district'] = null

            } else {
                let locality = commonState.locality.filter((el: any) => +el.city_id === +value.value)

                if (!(locality && locality.length)) {
                    props.setLoading(true)
                    let cityArray = [+value.value]
                    if (formFields.cur_city) cityArray.push(+formFields.cur_city)
                    locality = await dispatch(getLocalityList({ city: cityArray }))
                    locality = locality?.data?.filter((e: any) => e.city_id === +value.value) || []
                    props.setLoading(false)
                }

                setPerLocality([...locality]);

                if (formFields["per_sameas_cur"] === 2) {
                    curvalue = { cur_city: value.value }
                    curvalue['cur_barangay'] = null

                    setCurLocality([...locality])
                }
                formFields['per_barangay'] = null
            }
            formFields = { ...formFields, [key]: value.value, ...curvalue }

        } else if (key === "cur_city") {
            if (COUNTRY_CODE === 'id') {
                let district: any = await fetchDistrictList([+value.value])
                if (district?.length) {
                    setCurDistrict(district)
                }
                formFields['cur_district'] = null
            } else {

                let locality = commonState.locality.filter((el: any) => +el.city_id === +value.value);
                if (!(locality && locality.length)) {
                    props.setLoading(true)
                    let cityArray = [+value.value]
                    if (formFields.per_city) cityArray.push(+formFields.per_city)
                    locality = await dispatch(getLocalityList({ city: cityArray }))
                    locality = locality?.data?.filter((e: any) => e.city_id === +value.value) || []
                    props.setLoading(false)
                }

                setCurLocality([...locality]);
                formFields['cur_barangay'] = null
            }

            formFields = { ...formFields, [key]: value.value }

        } else if (key === "per_barangay") {
            let pin_code = { per_postal_code: value.pin_code };
            let curvalue = {};
            if (formFields["per_sameas_cur"] === 2) {
                curvalue = { cur_barangay: value.value, cur_postal_code: value.pin_code }
            }
            formFields = { ...formFields, [key]: value.value, ...pin_code, ...curvalue }

        } else if (key === "cur_barangay") {
            let pin_code = { cur_postal_code: value.pin_code };
            formFields = { ...formFields, [key]: value.value, ...pin_code }

        } else if (key === "per_sameas_cur") {
            let per_sameas_cur = 1; // by default unchecked
            let fieldDisable = false;
            let curvalue: any = { cur_house_no: '', cur_street: '', cur_region: '', cur_city: '', cur_barangay: '', cur_postal_code: '' };
            let isAgency = application_type_id === APP_TYPE_AGENCY

            if (isAgency) {
                curvalue['cur_full_address'] = ''
            }

            if (value.target.checked) {
                fieldDisable = true;
                per_sameas_cur = 2;
                curvalue = {
                    cur_full_address: props.residentialDetails.cur_full_address,
                    cur_house_no: props.residentialDetails.per_house_no,
                    cur_street: props.residentialDetails.per_street,
                    cur_region: props.residentialDetails.per_region,
                    cur_city: props.residentialDetails.per_city,
                    cur_barangay: props.residentialDetails.per_barangay,
                    cur_postal_code: props.residentialDetails.per_postal_code
                };

                if (isAgency) {
                    curvalue['cur_full_address'] = props.residentialDetails.per_full_address
                }
                setCurCity(perCity);
                setCurLocality(perLocality);
            } else {
                setCurCity([]);
                setCurLocality([]);
            }
            setCurFieldDisable(fieldDisable);

            formFields = { ...formFields, [key]: per_sameas_cur, ...curvalue }

        } else if (residentialDetailsForID.find((e: any) => e === key || ('per_' + e) === key || ('cur_' + e) === key)) {
            let curvalue: any = {}
            let fieldDisable = false
            let same_as_ktp = 1

            if (key === 'same_as_ktp_address') {
                let curvalue: any = { cur_housing: '', cur_rt: '', cur_rw: '', cur_city: '', cur_province: '', cur_district: '', cur_sub_district: '',cur_postal_code:'' };

                if (value.target.checked) {
                    fieldDisable = true
                    same_as_ktp = 2

                    residentialDetailsForID.forEach((subKey: any) => {
                        if (subKey !== key) {
                            curvalue['cur_' + subKey] = props.residentialDetails?.['per_' + subKey]
                        }
                    })
                    setCurCity(perCity);
                    setCurDistrict(perDistrict)
                } else {
                    setCurCity([]);
                    setCurDistrict([])
                }

                setCurFieldDisable(fieldDisable)
                formFields = { ...formFields, [key]: same_as_ktp, ...curvalue, cur_city: same_as_ktp === 2 ? props?.residentialDetails?.per_city : '' }
            } else {
                let isProvince = key.includes('province')
                let isDistrict = key.includes('district')
                let isPermanent = key.startsWith('per_')

                if (isProvince) {
                    if (isPermanent) {
                        let per_city = commonState.city.filter((el: any) => +el.state_id === +value.value);
                        setPerCity([...per_city]);
                        let curvalue = {};
                        if (formFields["same_as_ktp_address"] === 2) {
                            curvalue = { cur_province: value.value, cur_city: null, cur_district: null }
                        }
                        formFields = { ...formFields, [key]: value.value, ...curvalue, per_city: null, per_district: null }
                    } else {
                        let cur_city = commonState.city.filter((el: any) => +el.state_id === +value.value);
                        setCurCity([...cur_city]);

                        formFields = { ...formFields, [key]: value.value, cur_city: null, cur_district: null }
                    }
                } else if (isDistrict) {
                    if (isPermanent) {
                        let curvalue = {};
                        if (formFields["same_as_ktp_address"] === 2) {
                            curvalue = { cur_district: value.value }
                        }
                        formFields = { ...formFields, [key]: value.value, ...curvalue }
                    } else {
                        formFields = { ...formFields, [key]: value.value }
                    }
                } else if (formFields['same_as_ktp_address'] === 2) {
                    curvalue = { [key.replace('per', 'cur')]: value?.target?.value || value.value }
                }

                formFields = { ...formFields, [key]: value?.target?.value || value.value, ...curvalue }
            }
        } else {

            formFields = { ...formFields, [key]: value.target.value }
        }
        props.changeHandler(formFields, "residential-details");

        if (['per_postal_code', 'cur_postal_code', 'per_sameas_cur', 'same_as_ktp_address', 'per_barangay', 'cur_barangay'].includes(key)) {
            updatePostalCodeErrors(formFields);
        }
    }

    const fetchDistrictList = async (params: any) => {
        props.setLoading(true)

        dispatch(getLocalityList({ city: params })).then((res: any) => {
            if (res?.status === STATUS_SUCCESS) {
                return res.data
            }
        }).finally(() => {
            props.setLoading(false)
        })
    }


    const getFieldOptions = (fieldItemName: any) => {
        switch (fieldItemName) {

            case 'per_city':
            case 'cur_city': {
                if (fieldItemName.startsWith('per')) {
                    return perCity
                } else return curCity
            }

            case 'per_district':
            case 'cur_district': {
                if (fieldItemName.startsWith('per')) {
                    return perDistrict
                } else return curDistrict
            }
            default: {
                return []
            }
        }
    }

    let { errors, residentialDetails } = props;
   
    function getFieldMapping(type: string) {
        let key = type
        let placeholderMain = key === 'per' ? 'Permanent' : 'Current'
        let isDisabled = props.disable || (key === 'cur' ? curFieldDisable : false)

        return {
            PER_SAME_AS_CUR: (
                <fieldset className="form-filed col-md-12  m-b-1">
                    <div className="material">
                        <div className="custom-control custom-checkbox">
                            <input
                                id="per_sameas_cur"
                                name="per_sameas_cur"
                                type="checkbox"
                                onChange={(e: any) => changeHandler(e, 'per_sameas_cur')}
                                checked={(residentialDetails.per_sameas_cur === 2) ? true : false} value={residentialDetails.per_sameas_cur} className="custom-control-input"
                                disabled={props.disable}
                                placeholder=" "

                            />

                            <label className="custom-control-label">Same as Permanent Address </label>
                        </div>
                    </div>
                </fieldset>
            ),

            SAME_AS_KTP_ADDRESS: (
                type === 'cur' &&
                <fieldset className="form-filed col-md-12  m-b-1">
                    <div className="material">
                        <div className="custom-control custom-checkbox">
                            <input
                                id="same_as_ktp_address"
                                name="same_as_ktp_address"
                                type="checkbox"
                                onChange={(e: any) => changeHandler(e, 'same_as_ktp_address')}
                                checked={(residentialDetails.same_as_ktp_address === 2) ? true : false} value={residentialDetails.same_as_ktp_address} className="custom-control-input"
                                disabled={props.disable}
                                placeholder=" "

                            />

                            <label className="custom-control-label"> {translations.Insurance?.[policy_type_id===POLICY_HOLDER['COMPANY']?'SAME_AS_COMPANY_ADDRESS':'Same as KTP Address']} </label>
                        </div>
                    </div>
                </fieldset>
            ),

            FULL_ADDRESS: (
                application_type_id === APP_TYPE_AGENCY
                    ?
                    <fieldset className="col-md-6">
                        <div className="material" title={residentialDetails?.[key + '_full_address']}>
                            <InputField
                                inputProps={{
                                    id: (key + '_full_address'),
                                    name: (key + '_full_address'),
                                    className: "form-input",
                                    type: "text",
                                    value: residentialDetails?.[key + `_full_address`] || '',
                                    maxLength: '',
                                    disabled: isDisabled,
                                    placeholder: " "
                                }}
                                onChange={(e: any) => changeHandler(e, (key + '_full_address'))}
                            />
                            <label data-label={placeholderMain + " Full Address*"} className="form-label"></label>
                            {
                                errors?.[key + '_full_address'] ?
                                    <span className="error-txt">{errors?.[key + '_full_address']}</span>
                                    : ''
                            }
                        </div>
                    </fieldset>
                    : null
            ),

            HOUSING: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_housing']}>
                        <InputField
                            inputProps={{
                                id: key + "_housing",
                                name: key + "_housing",
                                className: "form-input",
                                type: "text",
                                value: residentialDetails?.[key + '_housing'] || '',
                                maxLength: '',
                                disabled: isDisabled,
                                placeholder: " "
                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_housing'))}
                        />
                        <label data-label= {`${translations.Insurance?.['Housing'] || translations.commonMsg?.loading} *`}className="form-label"></label>
                        {
                            errors?.[key + '_housing'] ?
                                <span className="error-txt">{errors?.[key + '_housing']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),

            HOUSE_NO: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_house_no']}>
                        <InputField
                            inputProps={{
                                id: key + "_house_no",
                                name: key + "_house_no",
                                className: "form-input",
                                type: "text",
                                value: residentialDetails?.[key + '_house_no'] || '',
                                maxLength: '',
                                disabled: isDisabled,
                                placeholder: " "
                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_house_no'))}
                        />
                        <label data-label={`${placeholderMain} House Number${(isFieldReq)?'*':''}`} className="form-label"></label>
                        {
                            errors?.[key + '_house_no'] ?
                                <span className="error-txt">{errors?.[key + '_house_no']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),

            RT: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_rt']}>
                        <InputField
                            inputProps={{
                                id: "rt",
                                name: key + "_rt",
                                className: "form-input",
                                type: "text",
                                value: residentialDetails?.[key + '_rt'] || '',
                                maxLength: 3,
                                disabled: isDisabled,
                                placeholder: " "
                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_rt'))}
                        />
                        <label data-label= {`${translations.Insurance?.['RT'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                        {
                            errors?.[key + '_rt'] ?
                                <span className="error-txt">{errors?.[key + '_rt']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),

            STREET: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_street']}>
                        <InputField
                            inputProps={{
                                id: key + "_street",
                                name: key + "_street",
                                className: "form-input",
                                type: "text",
                                value: residentialDetails?.[key + '_street'] || '',
                                maxLength: '',
                                disabled: isDisabled,
                                placeholder: " "

                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_street'))}
                        />
                        <label data-label={`${placeholderMain} Street${(isFieldReq)?'*':''}`} className="form-label"></label>
                        {
                            errors?.[key + '_street'] ?
                                <span className="error-txt">{errors?.[key + '_street']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),

            RW: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_rw']}>
                        <InputField
                            inputProps={{
                                id: "rw",
                                name: key + "_rw",
                                className: "form-input",
                                type: "text",
                                value: residentialDetails?.[key + '_rw'] || '',
                                maxLength: 3,
                                disabled: isDisabled,
                                placeholder: " "
                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_rw'))}
                        />
                        <label data-label={`${translations.Insurance?.['RW'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                        {
                            errors?.[key + '_rw'] ?
                                <span className="error-txt">{errors?.[key + '_rw']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),

            REGION: (
                <ReactSelect
                    options={commonState?.state}
                    value={commonState?.state.find((v: any) => Number(residentialDetails?.[key + '_region']) === +v.value) || null}
                    placeholder={placeholderMain + " Region *"}
                    isDisabled={isDisabled}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                    fieldKey={key + "_region"}
                    fieldSetClassName="col-md-6"
                    errorField={errors?.[key + '_region']} />
            ),

            PROVINCE: (
                <ReactSelect
                    options={commonState?.state}
                    value={commonState?.state.find((v: any) => Number(residentialDetails?.[key + '_province']) === +v.value) || null}
                    placeholder={`${translations.Insurance?.[placeholderMain] || translations.commonMsg?.loading}  ${translations.Insurance?.['Province'] || translations.commonMsg?.loading} *`}
                    isDisabled={isDisabled}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                    fieldKey={key + "_province"}
                    fieldSetClassName="col-md-6"
                    errorField={errors?.[key + '_province']} />
            ),

            CITY: (
                <ReactSelect
                    options={getFieldOptions(key + "_city")}
                    value={(key === 'per' ? perCity : curCity)?.find((v: any) => Number(residentialDetails?.[key + '_city']) === Number(v.value)) || null}
                    placeholder={`${translations.Insurance?.[placeholderMain] || translations.commonMsg?.loading}  ${translations.Insurance?.['City'] || translations.commonMsg?.loading} *`}
                    isDisabled={isDisabled}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                    fieldKey={key + "_city"}
                    fieldSetClassName="col-md-6"
                    errorField={errors?.[key + '_city']} />
            ),

            BARANGAY: (
                <ReactSelect
                    options={key === 'per' ? perLocality : curLocality}
                    value={(key === 'per' ? perLocality : curLocality)?.find((v: any) => +residentialDetails?.[key + '_barangay'] === +v.value) || null}
                    placeholder={placeholderMain + " Barangay *"}
                    isDisabled={isDisabled}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey={key + "_barangay"}
                    fieldSetClassName="col-md-6"
                    errorField={errors?.[key + '_barangay']} />
            ),

            DISTRICT: (
                <ReactSelect
                    options={getFieldOptions(key + '_district')}
                    value={(key === 'per' ? perDistrict : curDistrict)?.find((v: any) => +residentialDetails?.[key + '_district'] === +v.value) || null}
                    placeholder={`${translations.Insurance?.[placeholderMain] || translations.commonMsg?.loading}  ${translations.Insurance?.['District'] || translations.commonMsg?.loading} *`}
                    isDisabled={isDisabled}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                    fieldKey={key + "_district"}
                    fieldSetClassName="col-md-6"
                    errorField={errors?.[key + '_district']} />
            ),

            SUB_DISTRICT: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_sub_district']}>
                        <InputField
                            inputProps={{
                                id: key + "_sub_district",
                                name: key + "_sub_district",
                                className: "form-input",
                                type: "text",
                                value: (residentialDetails?.[key + '_sub_district']) ? residentialDetails?.[key + '_sub_district'] : '',
                                maxLength: '',
                                disabled: isDisabled,
                                placeholder: " "

                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_sub_district'))}
                        />
                        <label data-label= {`${translations.Insurance?.[placeholderMain] || translations.commonMsg?.loading}  ${translations.Insurance?.['Sub District'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                        {
                            errors?.[key + '_sub_district'] ?
                                <span className="error-txt">{errors?.[key + '_sub_district']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),
            POSTAL_CODE: (
                <fieldset className="col-md-6">
                    <div className="material" title={residentialDetails?.[key + '_postal_code']}>
                        <InputField
                            inputProps={{
                                id: key + "_postal_code",
                                name: key + "_postal_code",
                                className: "form-input",
                                type: "text",
                                inputMode: "numeric",
                                pattern: "\\d{5}",
                                value: (residentialDetails?.[key + '_postal_code']) ? residentialDetails?.[key + '_postal_code'] : '',
                                maxLength: '5',
                                disabled: isDisabled,
                                placeholder: " "

                            }}
                            onChange={(e: any) => changeHandler(e, (key + '_postal_code'))}
                            validation={{
                                regex: /^\d*$/,
                                minLength: 5,
                                maxLength: 5,
                                errorMessage: "Postal code must contain exactly 5 numeric digits."
                            }}
                        />

                        <label data-label= {`${translations.Insurance?.[placeholderMain] || translations.commonMsg?.loading}  ${translations.Insurance?.['POSTAL_CODE'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                        {
                            errors?.[key + '_postal_code'] ?
                                <span className="error-txt">{errors?.[key + '_postal_code']}</span>
                                : ''
                        }
                    </div>
                </fieldset>
            ),
        }
    }


    const permanentFields: any = getFieldMapping('per');
    const currentFields: any = getFieldMapping('cur')

    const visiblePermanentFields = Object.keys(permanentFields)?.filter((field: any) => field !== 'PER_SAME_AS_CUR' && FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['RESIDENTIAL_DETAILS'][field])
    const visibleCurrentFields = Object.keys(currentFields)?.filter((field: any) => FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['RESIDENTIAL_DETAILS'][field])


    const ADDRESS_KEY = policy_type_id === POLICY_HOLDER['COMPANY']?'COMPANY_ADDRESS':'KTP_ADDRESS'

    return (
        <React.Fragment>
            <div className="">
                <div className='customer-heading-txt'>
                    <h2>{translations.Insurance?.['Residential Details'] || translations.commonMsg?.loading}</h2>
                    <span className='current-address-txt'>
                        {
                           `${translations.Insurance?.[FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['RESIDENTIAL_DETAILS'][ADDRESS_KEY]] || translations.commonMsg?.loading}` || 'Permanent Address'
                        }
                    </span>
                </div>
                <div className="row">
                    {
                        visiblePermanentFields.map((field: any) => {
                            return (
                                <React.Fragment key={field}>
                                    {permanentFields[field]}
                                </React.Fragment>
                            )
                        })
                    }
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <span className='mailing-address-txt'>{translations.Insurance?.['Mailing Address'] || translations.commonMsg?.loading}</span>
                    </div>

                    {
                        visibleCurrentFields?.map((field: any) => {
                            return (
                                <React.Fragment key={field}>
                                    {currentFields[field]}
                                </React.Fragment>
                            )
                        })
                    }
                </div>
            </div>
        </React.Fragment >
    );
}
